import React from 'react';
import { ClockIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="w-full bg-white py-16" data-id="element-106">
      <div className="container mx-auto px-4 md:px-8" data-id="element-107">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-108">
          <div className="md:w-1/2" data-id="element-109">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" data-id="element-110">
              "It was <span className="text-gray-900" data-id="element-111">2:37 AM</span> and I was{' '}
              <span className="text-gray-900" data-id="element-112">pacing my kitchen floor</span>."
            </h1>
            <p className="text-2xl mb-6 text-gray-800" data-id="element-113">
              Every step across the cold tiles sent{' '}
              <span className="font-bold" data-id="element-114">fire shooting through my knee</span>.
            </p>
            <p className="text-2xl mb-8 text-gray-800" data-id="element-115">
              I whispered out loud: "
              <span className="font-bold" data-id="element-116">Why can't I just sleep?</span>"
            </p>
            <div className="flex items-center gap-2 bg-gray-100 p-6 rounded-lg" data-id="element-117">
              <ClockIcon className="w-8 h-8 text-gray-700" data-id="element-118" />
              <p className="text-xl text-gray-800" data-id="element-119">
                In the UK, more than 8 million people live with osteoarthritis.
                And one of the most common complaints?{' '}
                <span className="font-bold" data-id="element-120">
                  Sleepless nights from burning, stabbing knee pain.
                </span>
              </p>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-121">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uo83E5DNpdpQSDjWbNkofr/ChatGPT_Image_1_aug_2025%2C_22_39_25.png" alt="Woman awake at 2:37 AM with knee pain" className="rounded-lg shadow-xl w-full" data-id="element-122" />
          </div>
        </div>
      </div>
    </section>;
};